module.exports = __webpack_public_path__ + "img/octopus.6164c3e0.png";